module.exports = {
    load_more: '加载更多',
    version: '版本',
    officeTime: '09:00-21:00',
    WechatText: '使用微信扫描二维码联系客户经理',
    bookOrder: {
        enterToast: '出发时间或者持续时间未填写',
        agree: '请同意《服务条款》和《取消政策》',
        error: '结束时间必须在深夜12点之前',
        cancelTitle: '取消政策',
        serviceTitle: '服务条款',
        termsTitle: '服务条款',
        policyTitle: '取消政策',
    },
    order: {
        time: '请选择出发时间',
        hour: '请选择持续时间',
        departure_time: '出发时间',
    },
    loginForm: {
        verification_code: '请输入验证码',
        loginSuccess: '登录成功',
        phoneLoginTitle: '手机号码登录',
        emailLoginTitle: '邮箱登录',
    },
    month: {
        January: '一月',
        February: '二月',
        March: '三月',
        April: '四月',
        May: '五月',
        June: '六月',
        July: '七月',
        August: '八月',
        September: '九月',
        October: '十月',
        November: '十一月',
        December: '十二月',

        JANUARY: '一月',
        FEBRUARY: '二月',
        MARCH: '三月',
        APRIL: '四月',
        MAY: '五月',
        JUNE: '六月',
        JULY: '七月',
        AUGUST: '八月',
        SEPTEMBER: '九月',
        OCTOBER: '十月',
        NOVEMBER: '十一月',
        DECEMBER: '十二月',
    },
    form: {
        outDate: '当前时间已过期。请选择正确的时间',
        h: '小时',
        success: '成功',
        fail: '失败',
        ok: '确认',
        back: '取消',
        nameCheck: '用户名不能为空且不能超过64位字符',
        phoneCheck: '区号+手机号6-20位',
        adultsCheck: '成人人数必须是数字且不为空',
        childrenCheck: '儿童人数必须是数字',
        endDateCheck: '结束时间不能为空',
        benginDate: '开始时间不能为空',
        dateCheck: '日期不能为空',
        timeCheck: '旅游时间不能为空',
        hoursCheck: '时间不能为空',
        qzCheck: '区号必须是数字且不能为空',
        emailCheck: '邮箱格式不正确',
        peoplesCheck: '人数大于游艇的容量',
        maxPeople: '乘客超过最大容量',
        timeBar: '开始时间不能超过结束时间',
        mustAdultCheck: '至少要有一位成人',
        minTime: '最小时间:',
        messageBoard: '留言不能为空',
        countDown: '倒计时',
    },
    sportSelectTime: '请选择时间和日期',
    selectMinRentTime: '该项目的最短持续时间为：',
    sportDate: '日期',
    noData: '"暂时没有数据"',
    ft: '英尺',
    upTo: '最多',
    pax: '人',
    // Quick Order
    quickyorderdeparture_point: '出发地点',
    quickyorderyacht_length: '游艇长度',
    quickyorderdeparture: '出港时间',
    quickyorderarrival: '回港时间',
    quickyorderduration: '持续时长',
    quickyorderproples: '成人/儿童',
    quickyordername: '名字',
    quickyorderphone: '手机号码',
    quickyorderemail: '电子邮箱',
    quickyordertotal: '总额(含 5% 增值税)',
    quickyorderclose: '关闭',
    quickyordercheckout: '立即结账',
    quickyordercancel: '取消',
    quickyorderok: '确定',
    quickyorderPayTitle: '确定继续支付吗？',

    // home
    loginTitle: '登录您的帐户',
    verification_code: '验证码',
    get_verification_code: '获取验证码',
    me: '我的',
    login: '登录',
    news: '最新消息',
    contact: '联系我们',
    team: '公司团队',
    call: '联系我们',
    contactUS: '联系我们',
    wechat: '微信',
    charter: '游艇整租',
    super: '超级游艇',
    waterSports: '水上运动',
    fishing: '钓鱼俱乐部',
    tours: '游艇散拼',
    officeHours: '营业时间',
    officePhone: '联系电话',
    email: '联系邮箱',
    marina: '天行者游艇 1002, Marina Plaza 办公大楼, 迪拜',
    yachtRental: '天行者游艇租赁2022',
    services: '服务项目',
    help: '帮助中心',
    aboutUs: '关于我们',
    fqa: '常见问答',
    main: '保养',
    social: '社群媒体',
    partners: '我们的合作伙伴',
    superYacht: '超级游艇咨询',
    yourName: '姓名',
    mobileNum: '手机号码',
    emails: '电子邮箱',
    yacht: '游艇',
    adults: '成年人',
    tourDate: '旅行日期',
    sendBtn: '发送咨询',
    nameRule: '请输入你的名称',
    mobileRule: '请输入你的手机号',
    aboutus: '关于我们',
    aboutUs_content:
        '天行者游艇于2020年3月进入迪拜游艇租赁市场。提供东西方联合的强大领导力，并拥有超过25年的全球特许经营经验。我们承诺对天行者团队和机队进行大量投资，以倡导一种无与伦比的以消费者为中心的方法。我们的新船设计不仅有助于更新行业标准，还实现了可持续发展，不再使用化石燃料，为消费者提供更顺畅、无缝和环境更清洁的租船体验。',
    summer1: '夏季优惠',
    summer2: '',
    summer3: '使用码 ',
    yacht_filter: '游艇筛选',
    select_date: '选择日期',
    select_date_text: '请选择日期',
    charter_hours: '租船时长',
    charter_time: '租船时间',
    number_guests: '人数',
    yachts_lists_title: '单价',
    yachts_lists_name: '',
    yachts_lists_book: '预订',
    yachts_lists_instantly: '立即',
    yachts_lists_address: '地点',
    yachts_lists_capacity: '容积',
    yachts_lists_crew: '船员',
    yachts_charter: '我们所有的包租包括免费的毛巾，浮潜设备，水，冰和软饮料',
    yachts_charter_btn: '点击这里了解更多信息',
    map_title: '游艇巡航地图',
    map_position: '迪拜港口',
    map_hour1: '1小时之旅',
    map_hour2: '2小时之旅',
    map_hour3: '3小时之旅',
    map_address1: '玛丽娜运河',
    map_address2: '玛丽娜运河 + 阿拉伯塔酒店',
    map_address3: '玛丽娜运河  + 亚特兰提斯 + 阿拉伯塔酒店',
    walker_title: '天行者的体验',
    // super
    super_yachts: '超级游艇包租',
    super_banner_text:
        'Sky Walker超级游艇租赁开启了通往迪拜真正奢华生活的大门。我们能够为您量身定制提出的所有需求，帮助您创造非凡的时刻和一生的回忆。从选择Sky Walker开始，对于您每一次豪华游艇之旅的良好体验我们都充满信心！',
    super_nav_l: '免费VIP接送',
    super_nav_r: '美食',
    super_nav_rs: '配备行政主厨制作绝佳的美食供您享用',
    enquire: '立即咨询',
    super_tip_charter: '租赁',
    super_tip_charter1: '/每小时',
    super_tip_charter24: '24小时',
    build: '建造',
    cabins: '客舱',
    berth: '泊位',
    sleeps: '睡眠舱',
    startTime: '开始时间',
    endTime: '结束时间',
    super_detail1:
        'Sunseeker 再次创造了一艘完美无瑕的船 -- Notorious，这解释了为什么它是业内公认的知名品牌。这艘船的建造纯粹是为了表达它的奢华和风格，给人一种皇室的感觉，你不应该错过的。一旦您登上 Notorious，您会发现自己被完美的设计、豪华的客舱和最新的娱乐所包围。',
    super_detail2:
        '这艘租来的105英尺长的豪华游艇由Numarine建造，在阿联酋的任何地方都将提供令人难忘的航海乐趣。Dolce Vita同样具有诱惑力和运动感的设计、高水平的功能和性能，在其他方船租赁服务中独树一帜。这艘豪华游艇是私人聚会和企业聚会的完美选择，每次最多可容纳25名乘客。',
    super_detail3:
        '由英国造船厂Sunseeker建造的35.2米/115英尺6英寸的机动游艇“Legende”在5个船舱内为最多10位客人提供灵活的住宿，并由英国设计师Sunseeker进行室内设计。',
    super_detail4:
        'Code8 164英尺长的摩托游艇由贝内蒂于1995年建造，最后一次改装是在2016年。该游艇拥有按摩浴缸、休息室酒吧和位于天空休息室的现场烧烤站，华丽的造型和奢华的座椅使她成为豪华游艇体验、企业活动和团队建筑的理想之选。住宿包括一间主卧套房、三间VIP包房和两间双人间。',
    super_detail5:
        '这是一款超级明星级体验，坐在一艘有着令人垂涎的观景平台的赛道边游艇上，这套精英套餐包括5*的热情款待，以及一个自由流动的碳香槟酒吧和美食菜单。这艘游艇位于亚斯码头（Yas Marina）的电气化氛围中，可以俯瞰南赛道上的所有活动。',
    super_detail6:
        '这是一款超级明星级体验，坐在一艘有着令人垂涎的观景平台的赛道边游艇上，这套精英套餐包括5*的热情款待，以及一个自由流动的碳香槟酒吧和美食菜单。这艘游艇位于亚斯码头（Yas Marina）的电气化氛围中，可以俯瞰南赛道上的所有活动。',

    // water
    senior: '高级讲师',
    senior_text:
        '我们的水上运动项目不仅适合初学者，也完全满足酷爱运动的发烧友。还等什么呢？快来加入我们尽情的享受吧。所有运动项目我们都配备有幽默的船长和经验丰富的教练，希望用我们的热情让您感受到宾至如归的感觉',
    senior_title: '冲浪',
    senior_title: '冲浪',
    cobalt: '宽敞的驾驶舱、宽敞的船头区域、可灵活转换的环绕式座椅、适用于全体船员的加长左舷座椅以及无与伦比的存储容量。 尽管仅凭这些功能就可以造就一艘出色的船，但 Cobalt R7 在乘坐舒适性方面也排名第一，赋予它无与伦比的奢华和价值——R7 一直被评为水上最佳弓骑手的众多原因中的几个。',
    length: '长度',
    capacity: '容量',
    berth: '泊位',
    dubai: '迪拜港口',

    knee_board: '膝板',
    wake_surf: '尾波滑水板',
    wake_board: '尾波板',
    jet_ski: '摩托艇',
    wake: '尾波',
    knee: '膝',
    boarding: '板',
    surfing: '冲浪',
    jet: '喷气式',
    skiing: '滑水运动',
    surfing1: '最少3个小时一场',
    surfing2: '对所有乘客开放',
    surfing3: '船上的教练和潜水员',
    surfing4: '所有运动和安全',
    difficulty: '难度系数',
    surf_btn: '立即预订',
    surf_question1: '我需要自带水上运动的相关设备吗？',
    surf_question2: '尾波冲浪很难吗？',
    surf_question3: '这是我第一次去体验如此酷的水上运动项目， 有人会告诉我怎么做吗？',
    surf_question4: '我是一名初学者。 我应该从哪里开始？ ',
    surf_question5: '尾波滑水比尾波冲浪更好玩吗？',
    surf_question6: '除此之外还包括哪些呢？',
    surf_question7: '我们可以自带冰淇淋、雪糕类的冷零食吗？',
    surf_answer1: '我们有冲浪板和救生夹克，只需要提前告知我们您喜欢的水上运动即可。',
    surf_answer2: '尾波冲浪刚接触时有一定难度，但我们认为您应该会去努力尝试这难忘的冲浪运动！',
    surf_answer3: '一位合格且经验丰富的运动教练将会在整个运动旅途中指导您如何完成整个过程。',
    surf_answer4: '这是一个较难回答清楚的问题，我们在想您为何不多花费一点时间去了解并尝试这些运动呢！',
    surf_answer5: '萝卜白菜各有所爱，您是属于哪种水上运动爱好者呢？',
    surf_answer6: '除了软饮料和水，我们将提供所有运动所需的安全设备。',
    surf_answer7: '当然可以',

    meet_post1: '高级讲师',
    meet_text1: '宽敞的驾驶舱、宽敞的船头区域、可灵活转换的环绕式座椅、适用于全体船员的加长左舷座椅以及足够的船舱空间',
    meet_post2: '高级讲师',
    meet_text2:
        '宽敞的驾驶舱、宽敞的船头区域、可灵活转换的环绕式座椅、适用于全体船员的加长左舷座椅以及无与伦比的存储容量。这些功能单独使用',
    meet_post3: '高级讲师',
    meet_text3:
        '宽敞的驾驶舱、宽敞的船头区域、可灵活转换的环绕式座椅、适用于全体船员的加长左舷座椅以及无与伦比的存储容量。这些功能单独使用',

    meetR_map: '常见问题',
    map_question: '联系我们了解更多：',
    what_do: '相关反馈',
    what_do_title1: '迪拜最佳冲浪点',
    what_do_title2: '非常感谢你们',
    what_do_text1:
        '非常不错的游艇，这里配备有适合所有级别客户使用的冲浪设备，以及专业的教练团队和乐于助人的船长。新迪拜港所在的位置风景优美，交通便利。可以直接在船上刷卡消费，整个体验过程轻松而又愉悦。',
    what_do_text2:
        '非常感谢你们为我这次带来的珍贵体验，我玩得非常尽兴，入门从滑板上站起来挺容易的，但我觉得还需要加强练习才能发现更多的乐趣。',
    now_add_fun: '现在添加娱乐项目',
    fun_your: '您的预订',
    your_yacht_name: '圣洛伦佐',

    crew: '船员',
    departure_date: '出发日期',
    duration: '持续时间',
    departure_point: '出发点',
    guest: '人数',
    on_board_catering: '船上餐饮',
    boards_menus: '菜单',
    boards_details: '详情',
    boards_price: '价格',
    boards_quantity: '数量',
    sports_menus: '水上运动',
    sports_unit: '单位',
    sports_price: '价格',
    sports_quantity: '数量',
    toys_menus: '游艇玩具',
    toys_unit: '单位',
    toys_price: '价格',
    toys_quantity: '描述',
    sport_title: '水上运动和游艇玩具',
    booking_summary: '预订统计',
    Name: '姓名',
    Phone: '手机号码',
    e_mail: '电子邮箱',
    Guests: '成人/儿童',
    Hours: '持续时间',
    Date: '出发日期',
    Location: '出发位置',
    charters: '租赁费',
    catering: '餐饮费',
    extras: '额外费用',
    total: '总额',
    total_inc: ' (含5%增值税)',
    agree: '我已阅读并同意',
    policy: '我已阅读并同意',
    policyrout: '《取消政策》',
    secure_pay: '安全支付：',
    checkout: '继续结算',
    agreerout: '《服务条款》',
    discount:'折扣',
    discount_list:'折扣列表',
    week:'星期',
    emptyData:'暂无数据',
    confirm:'确定',

    // comimg
    Coming: '敬请期待',
    num_days: '{num} 天',

    // tours
    adult: '成年人',
    child: '儿童',
    luxury_yacht_tours: '豪华游艇之旅',
    luxury_yacht_tours_tip:
        '租用豪华游艇游览阿拉伯海岸线不需要巨额预算。现在，你可以与家人和朋友一起见证迪拜的所有奇迹，只有梦想才能留下的难忘记忆',

    yacht_tours_operate_daily: '每日游艇之旅',
    live_virtual_tour: '实时虚拟游览',
    live_virtual_tour_under: '技术支持',
    book_instantly: '立即预订',
    yacht_code: '赶快下订！结账使用折扣码 <span>{code}</span> 享8折优惠',
    yacht_tour_experience: '体验游艇之旅',
    route_map: '线路图',
    tour_highlights: '旅行亮点',
    faq: '常见问题',
    map_question: '联系我们了解更多：',

    tours_yacht_detail1: '包括：导游、水、软饮料、新鲜水果和新鲜烤松饼',
    tours_yacht_detail2: '包括：导游、各式三明治、薯片、新鲜水果和新鲜烤松饼、水和软饮料',
    tours_yacht_detail3: '包括：导游、各式三明治、薯片、新鲜水果和新鲜烤松饼',
    tours_yacht_detail4: '包括：导游、水和软饮料',

    tour_question1: '游艇从哪里出发？',
    tour_question2: '可以下水游泳吗？',
    tour_question3: '有具体的着装要求吗？',
    tour_question4: '我们的行程之旅那天应该什么时候到达？',
    tour_question5: '我们在游艇上可以穿鞋吗？',
    tour_question6: '如果我迟到了怎么办？',
    tour_question7: '取消政策是什么？',
    tour_question8: '游艇旅途中会有停下来拍照的机会吗？',
    tour_question9: '我可以带食物和零食进来吗？',
    tour_question10: '我们可以自带酒水吗？',

    tour_answer1: '我们从迪拜港出发。',
    tour_answer2: '抱歉，不可以',
    tour_answer3: '没有要求，我们建议您穿适合当天天气的衣服。',
    tour_answer4: '请比预订时间提早20~30分钟到达即可。',
    tour_answer5: '为了乘客的安全以及保持游艇干净整洁，我们需要每位成员脱掉鞋子。',
    tour_answer6: '游艇将会在约定的时间准点启航。未能如约而至的成员我们深表歉意，恕不退款。',
    tour_answer7: '出发前24小时内免费取消。请注意，退款的时长可能需要多达14天后才能返还到您的帐户。',
    tour_answer8: '船长将允许您拍照并且满足您的要求，无需担心此次行程中无法拍照的遗憾',
    tour_answer9: '游艇上将提供餐食和软饮，烧烤将包括肉类、鸡肉和素食，以及配菜沙拉和面包。',
    tour_answer10: '抱歉，游艇上严禁饮酒。',

    march: '3月',
    april: '4月',
    may: '5月',

    read_more: '阅读更多',

    news_events: '新闻事件',

    // company
    company_version: '公司愿景',
    company_text:
        '天行者游艇公司是迪拜最受欢迎的游艇租赁公司之一。我们提供最优惠的价格和豪华游艇租赁服务，以日和小时为单位。每艘豪华游艇都可以从天行者租赁，天行者的游艇100％自有。我们提供专业的船舶租赁服务，有实力的后盾且我们团队皆是有多年航海经验的游艇船长及船员。我们的目标是为您提供最优质的游艇租赁体验，无与伦比的奢华及最高安全保障是我们服务的核心所在。',
    company_team_title1: '我们的团队',
    company_team_title2: '船长和船员',
    company_team_title3: '保养及维修团队',
    teams_post1: '总经理',
    teams_post2: '行政经理',
    teams_post3: '销售经理',
    teams_post4: '运营部副理',
    teams_post5: '运营部副理',
    teams_post6: '销售经理',
    teams_post7: '市场部经理',
    teams_post8: '人事专员',
    teams_post9: '行政专员',
    teams_post10: '行销专员',
    teams_post11: '平面设计师',
    teams_post12: '会计专员',
    teams_post13: '会计专员',
    teams_post14: '会计专员',
    teams_post15: '市场部经理',
    teams_post16: '销售专员',
    teams_post17: '销售专员',
    teams_post18: '销售专员',
    teams_post19: '运营部专员',
    teams_post20: '旅游部经理',
    teams_post21: '销售专员',
    teams_post22: '销售专员',
    teams_post23: '销售专员',
    teams_post24: '运营部专员',
    teams_post25: '行政前台',
    teams_post26: '运营部司机',
    teams_post27: '运营部司机',
    teams_post28: '运营部司机',

    captain_post1: '船长',
    captain_post2: '船长',
    captain_post3: '船长',
    captain_post4: '船长',
    captain_post5: '船长',
    captain_post6: '船长',
    captain_post7: '船长',
    captain_post8: '船长',
    captain_post9: '船长',
    captain_post10: '船长',
    captain_post11: '船员',
    captain_post12: '船员',
    captain_post13: '船员',
    captain_post14: '船员',
    captain_post15: '摩托艇教练',
    captain_post16: '船员',
    captain_post17: '船员',
    captain_post18: '船员',
    captain_post19: '船员',
    captain_post20: '船员',
    captain_post21: '船员',
    captain_post22: '船员',
    captain_post23: '喷气滑雪队长',
    captain_post24: '船员',
    captain_post25: '船员',
    captain_post26: '船员',
    captain_post27: '船员',
    captain_post28: '船员',
    captain_post29: '船员',
    captain_post30: '船员',
    captain_post31: '船员',
    captain_post32: '船员',
    captain_post33: '船员',
    repair_post1: '木匠',
    repair_post2: '工程师',
    repair_post3: '电气工程师',
    repair_post4: '油漆工',
    repair_post5: '电气工程师',
    repair_post6: '工程师',
    repair_post7: '行政',

    // water_booking
    water_title: '水上运动预订',
    Adults: '成年人数',
    Childs: '儿童人数',
    hour: '小时',
    activity: '活动',
    total_cost: '总额(含5%增值税)',
    close: '关闭',
    checkout_btn: '结帐',
    // yachts_book
    yachts_book_title: '三步中的第一步',
    proceed: '继续',
    noData: '"暂时没有数据"',
    // tour_booking
    tour_booking_title: '游艇散拼预订',
    tour_date: '旅行日期',
    tour_time: '旅行时间',
    children: '儿童人数',
    infants: '婴儿们 (0-6)',

    //office
    office_title: '天行者游艇办公室',
    office_form_label1: '联系表单',
    your_name: '姓名',
    intl_code: '国际代码',
    mobile_number: '手机号码',
    office_form_label6: '内容',
    office_form_btn: '发送咨询',
    office_contact_info: '联系信息',

    phone: '手机',
    booking: '预约',
    booking_hotline: '预订热线',
    sales_enquiry: '订单查询',
    marketing_enquiry: '行销部',
    career_opportunity: '加入我们',
    complaints: '投诉',
    feedback: '反馈',
    office_address: '办公室',
    location_pin: '地点',
    office_hours: '营业时间',
    office_address_value: '1002，Marina Plaza',
    google_maps: '谷歌地图',
    office_hours_value: '周一~周日',
    address: '地址',
    directions: '地点',
    contacts3_title: '天行者岗亭',
    contacts3_address: '迪拜码头步行街',

    news_title1: 'F1游艇之旅',
    news_desc1:
        '这是一款超级明星级体验，坐在一艘有着令人垂涎的观景平台的赛道边游艇上，这套精英套餐包括5*的热情款待，以及一个自由流动的碳香槟酒吧和美食菜单。这艘游艇位于亚斯码头（Yas Marina）的电气化氛围中，可以俯瞰南赛道上的所有活动。',
    news_title2: '天行者租船',
    news_desc2:
        '乘坐私人游艇在迪拜体验新年前夕，免费参加比赛。在新年前夕租一艘游艇。选择顶级VIP游艇。迪拜VIP体验。豪华游艇。私人游艇租赁。',
    news_title3: '天行者钓鱼之旅',
    news_desc3:
        '让一位经验丰富的船长带你去迪拜附近的最佳捕鱼地点，在这次小组深海捕鱼之旅中，大多数地点都很难独立找到。当你在鱼探系统的引导下巡游到各个景点时，欣赏迪拜的天际线，并使用提供的鱼竿和鱼饵捕捉从梭鱼到鲷鱼等各种鱼类。',

    news_right_desc: '乘坐私人游艇在迪拜体验新年前夕，免费参加比赛。在新年前夕租一艘游艇。',
    payType: {
        success: '支付成功',
        fail: '支付失败',
        ok: '我知道了',
        back: '返回',
        again: '重新支付',
    },
    headSeo: {
        superTitle: '迪拜超级游艇租赁_超级豪华游艇包租_游艇包船定制服务-天行者游艇',
        superKey: '迪拜超级游艇租赁,迪拜超级游艇包租,迪拜豪华游艇整租,游艇包船定制服务',
        superDec:
            'Skywalker天行者游艇是迪拜领先的超级游艇租赁平台，提供迪拜超级豪华游艇包租、整租，同时为尊贵的客户提供超级游艇包船定制服务，满足客户个性化需求，享受非凡的豪华游艇之旅。',
        shareTitle: '迪拜游艇散拼_豪华游艇拼船_私人游艇合租出海-天行者游艇',
        shareKey: '迪拜游艇散拼,豪华游艇拼船,私人游艇合租出海,迪拜游艇拼船价格',
        shareDec:
            'Skywalker天行者游艇提供迪拜游艇散拼、豪华游艇拼船、私人游艇合租出海等服务，每天5个时间段出海，游艇散拼价格175-350迪拉姆不等，配有糕点、果汁、咖啡、烧烤等食品，为您带来非凡的体验。',
        teachTitle: '迪拜水上运动_水上摩托_尾波冲浪_尾波滑水-天行者游艇',
        teachKey: '迪拜水上运动,迪拜水上摩托,迪拜尾波冲浪,迪拜尾波滑水,造浪艇冲浪',
        teachDec:
            'Skywalker天行者游艇为客户提供各式各样的迪拜水上运动，有迪拜水上摩托、迪拜尾波冲浪、迪拜尾波滑水、造浪艇冲浪等多项运动，各项运动都有教练和潜水员陪伴，确保安全，为您带来非凡的水上体验。',
        fishTitle: '迪拜钓鱼俱乐部-迪拜深海钓鱼俱乐部',
        fishKey: '迪拜钓鱼俱乐部,迪拜深海钓鱼俱乐部',
        fishDec:
            '钓鱼有不同的风格，每种风格都使用不同类型的设备，迪拜的钓鱼俱乐部将帮助您学习钓鱼所需的一切。 查看所有钓鱼俱乐部的详细信息，请访问 Sky Walker。',
        teamTitle: '天行者游艇公司是迪拜最受欢迎的游艇租赁公司之一',
        teamKey: '天行者游艇公司,迪拜最受欢迎游艇公司,迪拜好评最多游艇公司',
        teamDec:
            '行者游艇公司是迪拜最受欢迎的游艇租赁公司之一，我们提供最优惠的价格和豪华游艇租赁服务，以日和小时为单位，我们船舶租赁服务专业，团队航海经验丰富，为客户提供最优质的游艇租赁体验及最高安全保障。',
        newsTitle: '迪拜游艇租赁新闻_游艇包租最新消息_游艇活动-天行者游艇',
        newsKey: '迪拜游艇租赁新闻,游艇包租最新消息,游艇活动',
        newsDec:
            '了解天行者游艇公司最新消息和活动，获取最新迪拜游艇租赁价格、预定、航程时间、超级游艇定制服务、水上运动及钓鱼俱乐部信息。',
        funTitle: '迪拜游艇租赁下单',
        funKey: '迪拜游艇租赁下单',
        funDec: '天行者游艇是迪拜最受欢迎的游艇租赁公司之一，提供最优惠的价格和豪华游艇租赁服务，想租游艇可天行者游艇下单。',
        contactTitle: 'SKY WALKER游艇办公室',
        contactKey: 'SKY WALKER游艇办公室',
        contactDec: '通过whatsapp或电话联系我们，我们全年365天每天上午9点至晚上9点开放。迪拜SKY WALKER游艇租赁。电话：+971 4 548 3302',
        notFoundTitle: '404错误！该页面不存在或者已经被删除！',
    },
}
